















































































































































































import { fetchSolicitudBaja } from '../fetchSolicitudBaja';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    DatePicker,
  },
})
export default class DatosGenerales extends ComponenteBaseStepper {
  @Prop({ required: true }) motivos: any;
  @Prop({ required: true }) editedItem: any;
  @Prop({ default: false }) datosActualizados: boolean;
  @Prop({ required: true }) cantClientes: number;
  @Prop({ required: true }) cantPerifericos: number;
  @Prop({ required: true }) cantEquipos: number;
  estados = ['Solicitado', 'Anulado'];
  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];
  destinosPosibles: any = [];
  rules = {
    required: (value: any) => !!value || 'Required.',
  };
  validarDatos() {
    this.menu = false;
    if (
      this.formFields.tramo.value != '' &&
      this.formFields.observacion.value.trim() != '' &&
      this.formFields.motivoTipo.value &&
      (this.formFields.estado.value == 'Solicitado' ||
        this.formFields.estado.value == 'Anulado')
    ) {
      this.$emit('valido', true);
    } else {
      this.$emit('valido', false);
    }
  }
  date = moment().format('YYYY-MM');
  menu = false;

  actualizarCantidades(equipos: number, perifericos: number, clientes: number) {
    this.formFields.cantidadEquipos.value = equipos;
    this.formFields.cantidadPerifericos.value = perifericos;
    this.formFields.cantidadClientes.value = clientes;
  }

  async getSolicitud() {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitudBaja(
      {
        solicitud: this.editedItem,
      },
      'conecta_solicitud_baja_cliente/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las solicitudes', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  esAnulado: boolean = false;
  esEjecutado: boolean = false;
  async cargarNumero() {
    let data = await this.getSolicitud();
    this.formFields.numero.value = data.bajaclinumero;
    this.formFields.motivoTipo.value = data.motiid;
    this.formFields.observacion.value = data.bajacliobs;
    this.formFields.tramo.value = moment(data.bajaclitramo).format('YYYY-MM');
    this.formFields.cantidaEquiposConfirmados.value =
      data.bajaclicant_equipo_real;

    this.formFields.cantidadClientes.value = this.datosActualizados
      ? this.cantClientes
      : data.bajaclicant;
    this.formFields.cantidadEquipos.value = this.datosActualizados
      ? this.cantEquipos
      : data.bajaclicant_equipos;
    this.formFields.cantidadPerifericos.value = this.datosActualizados
      ? this.cantPerifericos
      : data.bajaclicant_perifericos;

    if (data.estado == 'Anulado' || data.estado == 'Ejecutado') {
      this.esAnulado = true;
      this.esEjecutado = data.estado == 'Ejecutado';
      this.$emit('anulado', this.esAnulado);
    }

    this.formFields.estado.value = data.estado;
  }

  mounted() {
    this.cargarNumero();
  }

  formFields: {
    numero: any;
    motivoTipo: any;
    observacion: any;
    tramo: any;
    cantidadClientes: any;
    cantidadEquipos: any;
    cantidadPerifericos: any;
    estado: any;
    cantidadSimCards: any;
    cantidaEquiposConfirmados: any;
  } = {
    numero: {
      label: 'Número',
      value: '',
    },
    motivoTipo: {
      label: 'Motivo Tipo',
      value: '',
    },
    observacion: {
      label: 'Observación',
      value: '',
    },
    tramo: {
      label: 'Tramo',
      value: '',
    },
    cantidadClientes: {
      label: 'Cantidad Clientes',
      value: 0,
    },
    cantidadEquipos: {
      label: 'Cantidad Equipos',
      value: 0,
    },
    cantidadPerifericos: {
      label: 'Cantidad Periféricos',
      value: 0,
    },
    estado: {
      label: 'Estado',
      value: 'Solicitado',
    },
    cantidadSimCards: {
      label: 'Cantidad Sim Cards',
      value: 0,
    },
    cantidaEquiposConfirmados: {
      label: 'Cantida Equipos Confirmados',
      value: 0,
    },
  };

  // Globales
  $snotify: any;
  e1: number = 1;
  actual: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = false;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dictionaryFormErrors: any = {};
  disabledAccion: boolean = false;
  mensajeConfirmacion: any = '';

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  async editarSolicitud(): Promise<boolean> {
    let self = this;
    return fetchSolicitudBaja(
      {
        numero: this.nuevoDato.numero,
        estado: this.nuevoDato.estado,
        motivo: this.nuevoDato.motivo,
        observacion: this.nuevoDato.observacion,
        tramo: this.nuevoDato.tramo,
        cantidadClientes: this.nuevoDato.cantidadClientes,
        cantidadEquipos: this.nuevoDato.cantidadEquipos,
        cantidadPerifericos: this.nuevoDato.cantidadPerifericos,
        usuario: JSON.parse(window.localStorage.user).id,
      },
      'conecta_solicitud_baja_cliente/editar_solicitud_general'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Hubo un error al crear el detalle de la solicitud',
          {
            timeout: 3000,
          }
        );
        return false;
      });
  }

  /* async ejecutaEdicion() :boolean{
    let estado = await this.editarSolicitud
    return estado
  } */

  nuevoDato: any = {};
  async editarDato() {
    this.nuevoDato = {
      numero: this.formFields.numero.value,
      estado: this.formFields.estado.value,
      motivo: this.formFields.motivoTipo.value,
      observacion: this.formFields.observacion.value,
      tramo: this.formFields.tramo.value,
      cantidadClientes: this.formFields.cantidadClientes.value,
      cantidadEquipos: this.formFields.cantidadEquipos.value,
      cantidadPerifericos: this.formFields.cantidadPerifericos.value,
    };
    return await this.editarSolicitud();
    //return this.nuevoDato.numero;
  }
}
